import smCrypto from 'sm-crypto';

// 私钥和公钥
// const privateKey = '私钥'; // 你的私钥，通常是32字节的十六进制字符串
// const publicKey = '公钥'; // 对应的公钥，通常是64字节的十六进制字符串
const cipherMode = 1; // 1 - C1C3C2，0 - C1C2C3，默认为1

var Sm2Util = {
  /**
   * 加密
   * @param {Object} content 原文
   * @param {Object} publicKey 公钥
   */
  encrypt: function (content, publicKey) {
    if (content == '') return '';
    var result = smCrypto.sm2.doEncrypt(content, publicKey, cipherMode);
    return result
  },
  /**
   * 解密
   * @param {Object} encryptContent 密文
   * @param {Object} privateKey 私钥
   */
  decrypt: function (encryptData, privateKey) {
    // 后端传输过来的密文开头的两个字符通常也为04，因此解密时需要删除
    encryptData = encryptData.startsWith('04') ? encryptData.substr(2, encryptData.length) : encryptData;
    var content = smCrypto.sm2.doDecrypt(encryptData, privateKey, cipherMode);
    return content;
  },
  /**
   * 生成签名
   * @param {Object} content 原文
   * @param {Object} privateKey 私钥
   */
  sign: function (content, privateKey) {
    var signValue = smCrypto.sm2.doSignature(content, privateKey, {
      hash: true,
      der: true,
    });
    return signValue;
  },
  /**
   * 校验验签
   * @param {Object} content 原文
   * @param {Object} signValue 签名
   * @param  {Object} publicKey 公钥
   */
  verifySign: function (content, signValue, publicKey) {
    var verifyResult = smCrypto.sm2.doVerifySignature(content, signValue, publicKey,
      {
        hash: true,
        der: true,
      }
    );
    return verifyResult;
  }
}

export default Sm2Util
